import { IApiCredentials, IProfile, IProfileSettings } from 'entities/User';
import { commonApi } from 'shared/api/commonApi';
import { EApiTags } from 'shared/typings';
import { getCookie } from 'shared/utils/getCookie';

export const accountApi = commonApi
	.injectEndpoints({
		endpoints: (builder) => ({
			getUserProfile: builder.query<IProfile, void>({
				query: () => ({
					url: `account/profile/`,
				}),
			}),

			getApiCredentials: builder.query<IApiCredentials, void>({
				query: () => ({
					url: `credentials/`,
				}),
			}),

			updateApiCredentials: builder.mutation<IApiCredentials, void>({
				query() {
					return {
						url: `credentials/reset/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'POST',
					};
				},
			}),

			updateProfile: builder.mutation<IProfileSettings, IProfileSettings>({
				query(body) {
					return {
						url: `account/profile/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'PATCH',
						body,
					};
				},
			}),

			updateSettings: builder.mutation<IProfileSettings, IProfileSettings>({
				query(body) {
					return {
						url: `account/settings/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'PUT',
						body,
					};
				},
			}),

			deleteAccount: builder.mutation<string, void>({
				query() {
					return {
						url: `account/delete/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'DELETE',
					};
				},
			}),
		}),
		overrideExisting: false,
	})
	.enhanceEndpoints({
		addTagTypes: [EApiTags.PROFILE, EApiTags.CREDENTIALS, EApiTags.CONFIG],
		endpoints: {
			getUserProfile: {
				providesTags: [EApiTags.PROFILE],
			},
			getApiCredentials: {
				providesTags: [EApiTags.CREDENTIALS],
			},
			updateApiCredentials: {
				invalidatesTags: [EApiTags.CREDENTIALS],
			},
			updateProfile: {
				invalidatesTags: [EApiTags.PROFILE],
			},
			updateSettings: {
				invalidatesTags: [EApiTags.CONFIG],
			},
		},
	});

export const {
	useGetUserProfileQuery,
	useUpdateSettingsMutation,
	useGetApiCredentialsQuery,
	useUpdateProfileMutation,
	useDeleteAccountMutation,
	useUpdateApiCredentialsMutation,
} = accountApi;
